import { CommonModule } from '@angular/common';
import { Component, EventEmitter, NgModule, OnInit, Output } from '@angular/core';
import { LinkModule } from '@app/directives/link.directive';

@Component({
  selector: 'app-action-button',
  templateUrl: './action-button.component.html',
  styleUrls: ['./action-button.component.scss']
})
export class ActionButtonComponent implements OnInit {

  @Output() clickEvent = new EventEmitter<any>();

  constructor() { }

  buttonClick(): void {
    if (this.clickEvent) {
      this.clickEvent.emit(true);
    }
  }

  ngOnInit() {
  }

}
@NgModule({
  declarations: [ActionButtonComponent],
  imports: [
    CommonModule,
    LinkModule,
  ],
  exports: [ActionButtonComponent]
})
export class ActionButtonModule { }
